import { postApi } from "./api_instance";

export const inquireRequest = async ({ formData }, dispatch) => {
  try {
    // console.log("Requesting inquiry with data:", formData);
    return await postApi({
      apiUrl: "/projects/api/inquiry",
      dispatch,
      sendToken: true,
      data: formData,
    });
  } catch (error) {
    console.error("Inquiry request failed:", error);
    throw error;
  }
};
